import urls from './urls';
import axios from 'axios';

class pushyApi {
  static pushyRegisterToken(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PUSHY_REGISTER_TOKEN;
    // return this.restClient.execute(url, ApiMethod.POST, params).then(res => res);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }
}

export default pushyApi;
